var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRiskActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.35717 0.952393H5.64288C4.95911 0.952393 4.40479 1.50671 4.40479 2.19049V2.80954C4.40479 3.49331 4.95911 4.04763 5.64288 4.04763H9.35717C10.0409 4.04763 10.5953 3.49331 10.5953 2.80954V2.19049C10.5953 1.50671 10.0409 0.952393 9.35717 0.952393Z",
    stroke: "#EFFEF5",
    strokeWidth: 1.38667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9048 2.19061H12.7619C13.0902 2.19061 13.4052 2.32106 13.6374 2.55324C13.8695 2.78543 14 3.10034 14 3.42871V15.8097C14 16.138 13.8695 16.453 13.6374 16.6851C13.4052 16.9173 13.0902 17.0478 12.7619 17.0478H2.2381C1.90973 17.0478 1.59482 16.9173 1.36263 16.6851C1.13045 16.453 1 16.138 1 15.8097V3.42871C1 3.10034 1.13045 2.78543 1.36263 2.55324C1.59482 2.32106 1.90973 2.19061 2.2381 2.19061H4.09524",
    stroke: "#EFFEF5",
    strokeWidth: 1.38667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0238 11.4762L6.88095 12.7143L10.5952 7.7619",
    stroke: "#EFFEF5",
    strokeWidth: 1.38667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskActive);
export default __webpack_public_path__ + "static/media/risk-active.c20ad3889afac63b2693696280d20b03.svg";
export { ForwardRef as ReactComponent };